import React from "react";
import styled from "styled-components";
import Viewr from "viewr";

const ViewrStyle = styled.div`
  .viewr {
    position: fixed;
    left: 10px;
    bottom: 10px;
    width: 90px;
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 36%);
    overflow: hidden;
    z-index: 999999;
    cursor: pointer;
    transition: ease 0.1s;
    background-color: rgba(0, 0, 0, 0.658);
  }
  .viewr.active {
    left: 0px;
    bottom: 0px;
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0%);
    display: flex;
    justify-content: center;
  }
  .viewr:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 66%);
  }
  .thumb-contain {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .viewr-container.active {
    border-radius: 0px;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
  }
  .viewr-container:not(.active) .v-feed {
    overflow-y: hidden;
  }
  .v-item {
    height: 100vh;
    display: flex;
    align-items: center;
    scroll-snap-align: start;
  }
  .viewr-container {
    opacity: 0;
    animation: fade 100ms 50ms forwards;
    position: fixed;
    left: 10px;
    bottom: 10px;
    height: 125px;
    border-radius: 10px;
    overflow: hidden;
    width: 90px;
    z-index: 5;
    background: rgba(0, 0, 0, 16%);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 16%);
    transition: 0.5s ease;
  }
  .feed-video {
    max-height: 100%;
    width: 100%;
  }
  .v-feed {
    max-width: 600px;
    scroll-snap-type: y mandatory;
    overflow-y: scroll;
  }
  /* width */
  .v-feed::-webkit-scrollbar {
    width: 0px;
  }
  /* Track */
  .v-feed::-webkit-scrollbar-track {
    background: #f1f1f175;
  }
  .v-actions span {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px;
  }
  .v-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  /* Handle */
  .v-feed::-webkit-scrollbar-thumb {
    background: rgba(136, 136, 136, 0.123);
  }
  /* Handle on hover */
  .v-feed::-webkit-scrollbar-thumb:hover {
    background: rgba(85, 85, 85, 0.277);
  }
  .viewr-container .v-actions::after {
    content: "";
    left: 0;
    bottom: 0;
    width: 100%;
    height: 160px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.75), transparent);
    z-index: -1;
    pointer-events: none;
    position: absolute;
  }
  .viewr-container .v-actions {
    position: absolute;
    z-index: +2;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 20px 40px;
    border-top: 1px solid rgb(255 255 255 / 28%);
    opacity: 0;
    animation: fade 400ms 400ms ease forwards;
  }
  .viewr-container .v-actions span {
    transition: 200ms ease;
  }
  .viewr-container .v-actions span:active {
    opacity: 0.6;
  }
  .viewr-container .v-feed {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    overflow-x: hidden;
    width: 100%;
    flex-wrap: wrap;
    overscroll-behavior: contain;
    scroll-snap-type: y mandatory;
    display: flex;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
    flex-flow: row wrap;
    overflow: auto;
    flex: none;
    touch-action: pan-y;
    scroll-behavior: smooth;
  }
  .viewr-container .v-top {
    position: absolute;
    z-index: +2;
    left: 0;
    top: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.45), transparent);
    z-index: -1;
    pointer-events: none;
    padding: 10px;
  }
  .viewr-container .v-top .loading-cell {
    width: 100%;
    margin: 5px;
    height: 2px;
    overflow: hidden;
    border-radius: 2px;
    background: rgba(230, 230, 230, 0.25);
  }
  .viewr-container .v-top .loading-cell .loading-cell-inner {
    transition: 250ms linear;
    height: 100%;
    background: rgba(230, 230, 230, 0.45);
  }
  .viewr-container .v-feed .feed-item {
    width: 100%;
    height: 100%;
    scroll-snap-align: start;
    position: relative;
  }
  .viewr-container .v-feed .pause-btn {
    position: absolute;
    left: 60%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 70%;
    z-index: 2;
  }
`;

const ViewrContainer = props => {
  const { urlList } = props;
  return (
    <ViewrStyle>
      <Viewr urlList={urlList} />
    </ViewrStyle>
  );
};

export default ViewrContainer;
